import dayjs from 'dayjs'
import type { SignedDocumentApiItem } from 'features/Procedure/state/procedure-api.type'
import { FormSelect } from './components/form-select/form-select'

type ColumnsParams = {
  selectedFormDocId: number | null
  onSelectForm: (doc: SignedDocumentApiItem) => void
}

export const formsTableColumns = ({ selectedFormDocId, onSelectForm }: ColumnsParams) => [
  {
    title: 'Document',
    dataIndex: 'select',
    key: 'select',
    ellipsis: false,
    render: (_: string, doc: SignedDocumentApiItem) => {
      return <FormSelect doc={doc} selectedFormDocId={selectedFormDocId} onSelect={onSelectForm} />
    },
  },
  {
    title: 'Date',
    dataIndex: 'docdate',
    key: 'docdate',
    render: (docdate: string) => {
      if (!docdate) return 'N/A'
      const date = dayjs(docdate)
      if (date.isValid()) {
        return date.format('MM/DD/YYYY')
      }
      return 'N/A'
    },
    sorter: {
      compare: (a: SignedDocumentApiItem, b: SignedDocumentApiItem) => {
        return dayjs(a.docdate).valueOf() - dayjs(b.docdate).valueOf()
      },
      multiple: 1,
    },
  },
]
